var map = {
	"./100.jpg": 999,
	"./100.png": 9332,
	"./11.jpg": 4878,
	"./CD.jpeg": 7305,
	"./CN.png": 2755,
	"./HP.jpeg": 4822,
	"./OIP.jpeg": 6416,
	"./St_Anthonys.jpg": 1498,
	"./aws.png": 3771,
	"./b.png": 9076,
	"./buld.jpg": 8543,
	"./codeInLogo.png": 7935,
	"./codeuino.jpg": 8394,
	"./coursera_logo.png": 1877,
	"./cra.png": 3634,
	"./dal.png": 6288,
	"./deeplearning_ai_logo.png": 2862,
	"./googleAssistant.jpg": 700,
	"./google_logo.png": 5927,
	"./hrishi2.png": 2223,
	"./hrishi222.png": 7326,
	"./ino.png": 6380,
	"./intel_logo.jpg": 3026,
	"./quicko.jpg": 917,
	"./sal.png": 5693,
	"./stanford_logo.png": 7137,
	"./tech9.webp": 6846,
	"./tech99.jpeg": 6383,
	"./vjt.png": 7115,
	"./wrighter.jpg": 7039
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1106;